// Map a WhatsApp Cloud API delivery failure (stored in ticket_messages.wa_error as
// "<code>: <title> — <detail>") to a clear, actionable agent-facing message. The bare
// "No entregado" left agents guessing ("como si el número no existiera"); these explain
// what actually happened and what to do.
//
// Known codes:
//  131047 — outside the 24h window → send an approved template to reopen the conversation.
//  130472 — recipient is in Meta's Argentina/LatAm experiment that DROPS business-initiated
//           MARKETING template messages. Not a number/format problem. Workarounds: use a
//           UTILITY-category template, or have the client message us first.
//  131026 / 131000 — undeliverable: the number has no WhatsApp or can't receive messages.
export function waFailReason(waError, t) {
  if (!waError) return t('tickets.waFailGeneric');
  const e = String(waError);
  if (e.startsWith('131047')) return t('tickets.waFailReengagement');
  if (e.startsWith('130472')) return t('tickets.waFailExperiment');
  if (e.startsWith('131026') || e.startsWith('131000') || e.startsWith('131049')) return t('tickets.waFailUndeliverable');
  return `${t('tickets.waFailGeneric')}: ${e}`;
}
